import { useEffect, useState } from 'react';

import { Box } from '@mui/material';
import axios from 'axios';
import { Navigate } from 'react-router-dom';

import { Loader, StickyHeader } from 'components';
import strings, { url } from 'constants/index';
import useAuth from 'contexts/AuthContext';

export const SCHEDULER_VIEWER_SCOPE = 'fixtures-api:scheduler-viewer';

const getSchedulerIframeUrl = () => {
  const apiUrl = (import.meta.env.VITE_FIXTURE_API || '/').replace(/\/$/, '');
  return `${apiUrl}/scheduler`;
};

const Scheduler = () => {
  const { user } = useAuth();
  const [isSessionReady, setIsSessionReady] = useState(false);

  useEffect(() => {
    axios
      .get(url.scheduler_session, { disableSuccessAlert: true })
      .then(() => setIsSessionReady(true))
      .catch(() => {
        // Error alerts are handled by the axios interceptor.
      });
  }, []);

  if (!user?.scope?.includes(SCHEDULER_VIEWER_SCOPE)) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <StickyHeader titleType={strings.scheduler} />
      {!isSessionReady ? (
        <Loader />
      ) : (
        <Box sx={{ height: 'calc(100vh - 180px)', width: '100%' }}>
          <iframe
            title={strings.scheduler}
            src={getSchedulerIframeUrl()}
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
        </Box>
      )}
    </>
  );
};

export default Scheduler;
